import React, { Component } from "react";
import TextInput from "../TextInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faFolder, faFile } from "@fortawesome/free-solid-svg-icons";

const FILE_TYPE = "static_file";
const FOLDER_TYPE = "folder";
const METHOD_CREATE = "Create";
const METHOD_RENAME = "Rename";
const ACCEPT_FILE_TYPES =
  "image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.ppt,.pptx,.xlsx,.xls,.txt,.svg,.csv,.epub";
/**
 * <EditModal item={}
 *   itemType={}
 *   fileRef={}
 *   handleInput={}
 *   handleClose={}
 *   handleSubmit={}
 *   canManage={}
 * />
 **/
const EditModal = (props) => {
  const { item, itemType } = props;
  const method =
    item != null && props.item.id == null ? METHOD_CREATE : METHOD_RENAME;
  const acceptFile = method === METHOD_CREATE && itemType === FILE_TYPE;
  const h2Str = `${method} ${props.itemType}`;
  const file = acceptFile ? (
    <div className="d-flex justify-content-center">
      <label className="">Upload File:</label>
      <span className="text-danger font-weight-bold ml-1 mr-2">*</span>
      <input
        type="file"
        accept={ACCEPT_FILE_TYPES}
        onChange={(e) => {
          props.handleInput(`modal_${itemType}[file]`, e);
        }}
      />
    </div>
  ) : (
    ""
  );

  return item != null ? (
    <div>
      <div
        className="modal-overlay"
        style={{
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          top: "0",
          bottom: "0",
          left: "0",
          right: "0",
          backgroundColor: "rgba(0, 0, 0, .5)",
          opacity: ".6",
        }}
        onClick={() => {
          props.handleClose(props.itemType);
        }}
      ></div>
      <div
        className="w-50 inner-buffer modal"
        role="dialog"
        style={{ display: "block", left: "25%", top: "10%", height: "auto" }}
      >
        <div className="modal-content inner-buffer">
          <div className="d-flex justify-content-left">
            <button
              className="btn btn-link text-decoration-none"
              onClick={() => {
                props.handleClose(itemType);
              }}
            >
              <FontAwesomeIcon icon={faTimes} color="red" size="lg" />
            </button>
          </div>
          <div className="d-flex justify-content-center">
            <h2>
              <FontAwesomeIcon
                color="lightblue"
                icon={itemType == FOLDER_TYPE ? faFolder : faFile}
              />
              <span className="pl-1">{h2Str}</span>
            </h2>
          </div>
          <hr />
          <form>
            <div className="d-flex justify-content-center">
              <TextInput
                valText={props.item.name}
                editMode={props.canManage}
                fieldName={`modal_${itemType}[name]`}
                labelText="Name: "
                handleChange={props.handleInput}
                maxLength={"100"}
                required={true}
              />
            </div>
            {file}
            <hr />
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-danger"
                onClick={() => {
                  props.handleClose(itemType);
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary ml-3"
                onClick={(e) => {
                  props.handleSubmit(itemType, e);
                }}
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};

export default EditModal;
